import { render, staticRenderFns } from "./group-subject.vue?vue&type=template&id=1723ed2a&scoped=true"
import script from "./group-subject.vue?vue&type=script&lang=js"
export * from "./group-subject.vue?vue&type=script&lang=js"
import style0 from "./group-subject.vue?vue&type=style&index=0&id=1723ed2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723ed2a",
  null
  
)

export default component.exports